var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{ref:"dialog",attrs:{"dialogTitle":_vm.dialogTitle,"dialogVisible":_vm.dialogVisible,"dialogModel":_vm.dialogModel,"rules":_vm.rules,"dialogWidth":"600px"},on:{"submitForm":_vm.handleSubmit,"closeDialog":_vm.closeDialog}})
}
var staticRenderFns = []

export { render, staticRenderFns }